export default function setScroolPositionAction(scrollPosition) {
    return {
        type: 'SET_SELECTED_SCROLL_POS',
        payload: scrollPosition
    }
}